module.exports = __webpack_public_path__ + "static/media/no-search@3x.7e67b68a.png";